const theme = {
    white: "#ffffff",
    black: "#000000",
    gray: "#9f9f9f",
    lightGray: "#d8d8d8",
    indigoBlue: "#1e1d54",
    yellow: "#ffd700",
}

export default theme;